import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import IntlComponent from 'axway-react-intl';
import CommandDialog from './CommandDialog';
import ComponentPanel from './ComponentPanel';

class ComponentUpdates extends React.Component {
	constructor(props) {
		super(props);
		IntlComponent.init(this);
		this.onUpdate = this.onShowDialog.bind(this, true);
		this.onCloseDialog = this.onShowDialog.bind(this, false);
		this.onRefresh = this.onRefresh.bind(this);
		this.state = {
			showUpdateModal: false
		};
	}

	onShowDialog(show, ev) {
		if (ev) {
			// close is not always triggered by ev
			ev.preventDefault();
			ev.stopPropagation();
		}
		this.setState({ showUpdateModal: show });
	}

	onRefresh() {
		this.props.refresh();
	}

	renderUpdateModal() {
		const text = (
			<div>
				<p>
					{this.intl.formatMsg('Running "npm update" will update all of your application\'s dependencies and is important for applying security and bug fixes, and should be done regularly. To update, do the following:')}
				</p>
				<ol>
					<li>{this.intl.formatMsg('Go to the terminal window and exit the application.')}</li>
					<li>{this.intl.formatMsg('Run the command below.')}</li>
					<li>{this.intl.formatMsg('Restart the server.')}</li>
					<li>{this.intl.formatMsg('Once the server is restarted, click the "Refresh" button to refresh the page.')}</li>
				</ol>
			</div>
		);

		return (
			<CommandDialog
				title={this.intl.formatMsg('Update {productName} components', this.props)}
				text={text}
				command="npm update"
				onClose={this.onCloseDialog}
				onOkay={this.onRefresh}
				closeText={this.intl.formatMsg('Cancel')}
				okayText={this.intl.formatMsg('Refresh')}
				okayIcon="redo2"
			/>
		);
	}

	render() {
		if (!this.props.updates.length) {
			return (
				<p>
					{this.intl.formatMsg('All updates have been installed.')}
				</p>
			);
		}

		return (
			<div>
				{this.state.showUpdateModal && this.renderUpdateModal()}
				<ComponentPanel
					title="updates"
					type="updates"
					onInstall={this.onUpdate}
					components={this.props.updates}
					productName={this.props.productName}
				/>
			</div>
		);
	}
}

ComponentUpdates.propTypes = {
	/**
	 * The updates available for the service.
	 */
	updates: PropTypes.array.isRequired,
	/**
	 * The function to use to refresh the UI.
	 */
	refresh: PropTypes.func.isRequired,
	/**
	 * The product name.
	 */
	productName: PropTypes.string.isRequired
};

export default injectIntl(ComponentUpdates);
